
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Gift } from 'lucide-react';

const EmailSignupSectionV3 = () => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);

  const handleEmailSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setIsSubscribed(true);
      console.log('Email subscribed:', email);
      
      // Analytics tracking can be added here
      // gtag('event', 'conversion', { send_to: 'AW-CONVERSION_ID/CONVERSION_LABEL' });
    }
  };

  return (
    <section id="waitlist-section" className="container max-w-5xl mx-auto px-4 py-24">
      <div className="bg-white/15 backdrop-blur-lg rounded-[3rem] p-16 text-center border border-white/20 shadow-2xl">
        <h3 className="text-5xl md:text-6xl font-black text-white mb-6 tracking-tight">
          Start Your First PACT
        </h3>
        <p className="text-xl text-white/90 mb-4 max-w-2xl mx-auto font-bold leading-relaxed">
          Join the experiment. Make a simple commitment. See what happens.
        </p>
        <p className="text-lg text-yellow-400 mb-12 font-bold">
          No forever pressure, just curiosity about what's possible.
        </p>
        
        {!isSubscribed ? (
          <div>
            <form onSubmit={handleEmailSubmit} className="flex flex-col sm:flex-row gap-6 max-w-lg mx-auto mb-8">
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                className="flex-1 bg-white/95 text-gray-900 border-0 rounded-2xl py-4 px-6 text-lg font-medium placeholder:text-gray-500 focus:bg-white transition-all"
                required
              />
              <Button
                type="submit"
                className="bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-500 hover:to-yellow-600 text-purple-800 rounded-2xl px-10 py-4 font-black text-lg transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                Start Experimenting
              </Button>
            </form>
            
            {/* Bonus */}
            <div className="bg-yellow-400/10 backdrop-blur-sm rounded-2xl p-6 border border-yellow-400/20 max-w-md mx-auto">
              <div className="flex items-center justify-center gap-3 mb-3">
                <Gift className="w-6 h-6 text-yellow-400" />
                <span className="text-yellow-400 font-bold text-lg">Bonus</span>
              </div>
              <p className="text-white font-medium">
                Get our <span className="text-yellow-400 font-bold">'PACT Design Guide'</span> when you join
              </p>
            </div>
          </div>
        ) : (
          <div className="animate-bounce-in">
            <div className="text-6xl mb-4">🧪</div>
            <p className="text-3xl font-black text-white mb-3">Welcome to the experiment!</p>
            <p className="text-xl text-white/90 font-medium mb-6">We'll send you the PACT Design Guide and notify you when we launch.</p>
            <div className="w-32 h-1 bg-yellow-400 rounded-full mx-auto mt-6"></div>
            <div className="mt-8">
              <a 
                href="/" 
                className="inline-block bg-white/20 text-white hover:bg-white/30 rounded-2xl px-8 py-4 font-bold text-lg transition-all duration-300 border border-white/30"
              >
                Try the App Now
              </a>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default EmailSignupSectionV3;
